module.exports = __webpack_public_path__ + "img/banner.a0e441a7.png";